import { ReactNode } from 'react';
import type { QuestionSettings } from '~/lib/Questions/Questions.types';
import { isAdminApp } from '~/public/lib/PageHelpers';

type QuestionLabelProps = {
    label?: ReactNode;
    settings?: QuestionSettings;
    className?: string;
};

const QuestionLabel = ({ label, settings, className }: QuestionLabelProps) => {
    const isAdmin =
        isAdminApp() &&
        !document.getElementsByClassName('is-designing-form')?.length;
    return (
        <div
            className={`${isAdmin ? 'input-label' : 'text-gray-700 text-base tracking-[0.25px]'}  mb-1 ${className}`}
        >
            {label}
            {!!settings?.required && label && (
                <span className="ml-1 text-red-600">*</span>
            )}
        </div>
    );
};

export default QuestionLabel;
